import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as AvatarSVG } from 'images/avatar.svg';

const Avatar = ({ url, alt, className }) => {
  if (!url) return <AvatarSVG className={className} />;
  return <img className={className} src={url} alt={alt || 'avatar'} />;
};

Avatar.propTypes = {
  url: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
};

Avatar.defaultProps = {
  url: null,
  alt: null,
  className: null,
};

export default Avatar;
